module.exports = __webpack_public_path__ + "img/avatar-login.9354abe2.png";